import axios from 'axios';

import { Id, PagedParams, PagedResponse, getData } from '@feature/utils';

import { EditorialTeam, EditorialTeamRequest } from './EditorialTeamTypes';

export function getPaged(params: PagedParams) {
  return axios
    .get<PagedResponse<EditorialTeam>>('/author/editorial-teams/paged', {
      params,
    })
    .then(getData);
}

export function get(id: Id) {
  return axios.get<EditorialTeam>(`/author/editorial-teams/${id}`).then(getData);
}

export function edit(id: Id, request: EditorialTeamRequest) {
  return axios.put<EditorialTeam>(`/author/editorial-teams/${id}`, request).then(getData);
}

export function create(request: EditorialTeamRequest) {
  return axios.post<EditorialTeam>(`/author/editorial-teams`, request).then(getData);
}

export function deleteById(id: Id) {
  return axios.delete<unknown>(`/author/editorial-teams/${id}`).then(getData);
}
